import { Stack, Text, ButtonGroup, Box } from '@chakra-ui/react';
import { NestedHome } from '@habity/types';
import { useEffect, useState } from 'react';
import { getDescription } from '~/lib/homes/profile/description';
import { ShowHideButton } from '../../../ui/Buttons';
import { isSellerClaimed } from '@habity/services';
import { extractFirstSentence } from '~/lib/text/extractFirstSentence';

export const ProfileDescriptionContent = ({ home }: { home: NestedHome }) => {
  const [showDescription, setShowDescription] = useState(false);

  useEffect(() => {
    setShowDescription(false);
  }, [home]);

  const description = getDescription(home);

  if (isSellerClaimed(home) || description.length === 0) {
    return null;
  }

  // Extract first sentence for preview using improved logic
  const firstSentence = extractFirstSentence(description);
  const hasMoreContent = description.length > firstSentence.length;

  return (
    <Stack
      pb="2"
      spacing={{ mobile: '4', desktop: '12' }}
      borderTopWidth={{ mobile: '1px', desktop: '0' }}
      borderTopColor="blackAlpha.200"
      pt={{ mobile: '4', desktop: '2' }}
      mt={{ mobile: '6', desktop: '0' }}
    >
      <Stack>
        <Text whiteSpace="pre-wrap" size="md" color="blackAlpha.700">
          {showDescription ? description : firstSentence}
        </Text>

        {hasMoreContent && (
          <ButtonGroup my="0" ml={{ mobile: '-5', desktop: '-6' }}>
            <Box px={2}>
              <ShowHideButton
                show={showDescription}
                onClick={() => setShowDescription(!showDescription)}
                size={{ mobile: 'sm', desktop: 'md' }}
                variant="plain"
              >
                {showDescription ? 'Läs mindre' : 'Läs mer'}
              </ShowHideButton>
            </Box>
          </ButtonGroup>
        )}
      </Stack>
    </Stack>
  );
};
